import React, { useState } from 'react';
import { postJSONPS } from '@cd/utils';
import { either } from '@cd/utils';
import { CenterProgress } from './component/CenterProgress';
import * as R from 'ramda';
import { useQuery } from '@cd/react-query';
import { useStore } from './payment/store';

const loadDataHOC =
	(method, url, options = {}) =>
	Cmp =>
	props => {
		const { dispatch } = useStore();
		const [data, setData] = useState(null);
		const { reactQuery } = options;
		const queryName = reactQuery?.queryName;

		const body = !options.body
			? {}
			: R.is(String, options.body)
			? JSON.parse(options.body)
			: options.body;

		if (!queryName) {
			console.log('ERRROR');
			return (
				<div style={{ color: 'red' }}>ERROR NO QUERY NAME {url}</div>
			);
		}
		const queryNameStr =
			body && !R.isEmpty(body)
				? [queryName, ...Object.values(body)]
				: queryName;

		useQuery(queryNameStr, () =>
			postJSONPS(method, url, options).then(
				either(
					e => dispatch({ type: 'post error', e }),
					data => {
						setData(data);
						return data;
					}
				)
			)
		);

		return data === null ? (
			<CenterProgress />
		) : data && data.length ? (
			<Cmp {...props} data={data} setData={setData} />
		) : (
			<div style={{ display: 'flex', justifyContent: 'center' }}>
				{props.noDataMessage}
			</div>
		);
	};

export { loadDataHOC };
